import { PhieuNhapKhoService } from '@/core/services/PhieuNhapKho.service';
import PhieuXuatKhoService from '@/core/services/Receipt.service';
import type { RouteLocationNormalized } from 'vue-router';

export type OwnerTicketResource = 'pnk' | 'pxk';

export interface OwnerTicketMeta {
  resource: OwnerTicketResource;
  /** Route param that holds the ticket id */
  param: string;
}

function resolveTicketId(
  to: RouteLocationNormalized,
  param: string
): number | null {
  const raw = to.params[param];
  const value = Array.isArray(raw) ? raw[0] : raw;
  const id = Number(value);

  return Number.isFinite(id) && id > 0 ? id : null;
}

/**
 * When the user lacks route permission, allow access if they own the ticket
 * (API returns can_edit === true).
 */
export async function canAccessAsTicketOwner(
  to: RouteLocationNormalized,
  ownerTicket: OwnerTicketMeta
): Promise<boolean> {
  const ticketId = resolveTicketId(to, ownerTicket.param);

  if (!ticketId) {
    return false;
  }

  try {
    if (ownerTicket.resource === 'pnk') {
      const {
        data: { data },
      } = await PhieuNhapKhoService.get(ticketId);

      return data.can_edit === true;
    }

    const {
      data: { data },
    } = await PhieuXuatKhoService.get(ticketId);

    return data.can_edit === true;
  } catch {
    return false;
  }
}
